import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { SaleModel } from '@shared/app/scripts/classes/sale-model';

import { find, isObject, isArray } from 'lodash';

export type IsTransactionStableFilter = (input: SaleModel) => boolean;

interface IIsTransactionStable {
  transform: IsTransactionStableFilter;
}

/**
 * Filter that returns false for transaction that waits for article data, true
 * otherwise
 * @param {Transaction} input Transaction object
 * @return {boolean} False of transactions waiting for update
 */
@Pipe({ name: 'isTransactionStable' })
export class IsTransactionStablePipe
  implements PipeTransform, IIsTransactionStable
{
  constructor() {
    'ngInject';
  }

  public transform(input: SaleModel): boolean {
    if (!isObject(input) || !isArray(input.receipt)) {
      return true;
    }

    if (find(input.receipt, { found: false })) {
      return false;
    }

    return true;
  }
}
